// GraphQL Queries
export const UPCOMING_EVENTS_QUERY = `
  query LiveEvents($hostId: ID!, $limit: Int) {
    host(id: $hostId) {
      events: hosting(states: [POSTED]) {
        nodes(limit: $limit) {
          id
          title
          maxQuantity
          ticketsSold
          waitlistCount
          soldOut
          salesAmount {
            monetaryAmount
            currency
          }
          timeSlots: availableTimeSlots {
            nodes(limit: 1) {
              id
              startAt
            }
          }
        }
      }
    }
  }
`;

export const RECENTLY_UPDATED_EVENTS_QUERY = `
  query RecentlyUpdatedEvents($hostId: ID!, $since: ISO8601DateTime) {
    host(id: $hostId) {
      id
      recentlyUpdatedEvents(since: $since) {
        nodes {
          id
          title
          lastUpdated
        }
      }
    }
  }
`;

export const EVENT_DETAIL_QUERY = `
  query Event($id: ID!, $timeSlotIds: [String!]) {
    event(id: $id) {
      slugParam
      capacity
      title
      waitlistCount
      nextFutureTimeSlot {
        id
        startAt
        endAt
      }
      rates(states: [ACTIVE, LOCKED, INACTIVE, HIDDEN], clientGroups: [EVERYWHERE]) {
        nodes {
          id
          name
          price
          displayPrice
          maxQuantity
          sortIndex
          state
        }
      }
      timeSlots(ids: $timeSlotIds) {
        nodes {
          id
          ratesAvailability: ratesAvailablity(states: [ACTIVE, INACTIVE, LOCKED])
          timeSlotReport {
            totalGross
            totalFee
            totalNet
            ticketsByDate
            salesByDate
            ticketItemsSold
          }
        }
      }
    }
  }
`;
